export enum FormatSelector {
  Specified = "Specified",
  AnyMatchedByObjectType = "AnyMatchedByObjectType",
  Any = "Any",
}
